var map = {
	"./africa/out-of-service.vue": [
		"qxKA",
		10
	],
	"./club-soft/out-of-service.vue": [
		"6+TJ",
		19
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6zDi";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/out-of-service lazy ^\.\/.*\/out\-of\-service\.vue$
// module id = 6zDi
// module chunks = 37